import React from 'react';
import { ListWrapper, ListHeading, ListItem, ListText } from './featureList.styled';

interface FeatureItem {
	label: string;
}

interface Modifiers {
	fontSize?: string;
	lineHeight?: string;
}

interface FeatureListProps {
	data?: FeatureItem[];
	title: string;
	icon: React.ReactNode;
	color?: string;
	modifiers?: Modifiers;
}

const FeatureList: React.FC<FeatureListProps> = ({ data = [], title, icon, color, modifiers }) => {
	return (
		<>
			<ListHeading $color={color}>{title}</ListHeading>
			<ListWrapper>
				{data &&
					data.map(({ label }, i) => (
						<ListItem key={i}>
							<ListText
								$fontSize={modifiers?.fontSize}
								$lineHeight={modifiers?.lineHeight}
								$isLast={i === data.length - 1}
							>
								{icon}
								{label}
							</ListText>
						</ListItem>
					))}
			</ListWrapper>
		</>
	);
};

export default FeatureList;
